import type { Project } from "@/lib/content/types";

export const projects: Project[] = [
  {
    slug: "stanton-springs-water-reuse-facility",
    name: "Stanton Springs Water Reuse Facility",
    location: "Stanton Springs, Social Circle",
    city: "Social Circle",
    county: "Newton",
    type: "industrial",
    status: "under-development",
    acreage: 207,
    partner: "Newton County Water & Sewerage Authority",
    description:
      "Prime Interest sold 207 acres to the Newton County Water & Sewerage Authority for a water reuse facility at Stanton Springs in Social Circle, adjacent to Meta/Facebook's data center and across from Rivian's electric vehicle manufacturing plant. The facility will serve industrial applications such as battery manufacturing and data center cooling. Sewer spray fields are to be developed on the balance of the acreage.",
    images: ["/images/projects/stanton-springs-water-reuse-facility.jpg"],
    featured: true,
    coordinates: [-83.746, 33.667],
  },
  {
    slug: "alta-dalton",
    name: "Alta Dalton Midrise Apartments",
    location: "501 West Waugh St., Downtown Dalton",
    city: "Dalton",
    county: "Whitfield",
    type: "luxury-apartments",
    status: "completed",
    units: 234,
    acreage: 4.899,
    partner: "Wood Partners",
    description:
      "Five-story mid-rise luxury apartments, surface parked, on 4.899 acres in the heart of Downtown Dalton.",
    images: [
      "https://www.woodpartners.com/wp-content/uploads/2024/04/The-Dalton_2024_Drone-Aerials_018-1-scaled.jpg",
      "https://www.woodpartners.com/wp-content/uploads/2024/04/The-Dalton_2024_Exteriors_122-scaled.jpg",
      "https://www.woodpartners.com/wp-content/uploads/2024/04/The-Dalton_2024_Drone-Aerials_003-scaled.jpg",
    ],
    featured: true,
    coordinates: [-84.971, 34.7698],
  },
  {
    slug: "northside-medical-office",
    name: "Northside Medical Office Buildings",
    location: "Rock Springs Rd. / Hwy. 20, Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "medical-office",
    status: "under-development",
    sqft: "200,000",
    partner: "Northside Hospital",
    description:
      "Two 100,000 sq ft medical office buildings near Coolray Field, developed for Northside Hospital.",
    images: [
      "https://wolfmediausa.com/wp-content/uploads/2024/05/Outpatient-Healthpeak-NorthsideMedicalBuford-2800BufordDr-LawrencevilleGAcropped.jpg",
    ],
    featured: true,
    coordinates: [-83.971, 34.1087],
  },
  {
    slug: "bellwood-park",
    name: "Bellwood Park",
    location: "Bolton Rd. / Donald Lee Hollowell Pkwy., Atlanta",
    city: "Atlanta",
    county: "Fulton",
    type: "townhomes",
    status: "completed",
    lots: 154,
    acreage: 12.25,
    partner: "McKinley Homes",
    description:
      "12.25-acre site delivering 154 townhome lots in the heart of Atlanta.",
    images: [
      "https://lirp.cdn-website.com/eb252c11/dms3rep/multi/opt/asantos_44-1920w.jpg",
      "https://lirp.cdn-website.com/eb252c11/dms3rep/multi/opt/asantos_42-1920w.jpg",
      "https://lirp.cdn-website.com/eb252c11/dms3rep/multi/opt/asantos_46-1920w.jpg",
      "https://lirp.cdn-website.com/eb252c11/dms3rep/multi/opt/asantos_32-1920w.jpg",
    ],
    featured: true,
    coordinates: [-84.4677, 33.7849],
  },
  {
    slug: "the-stables-motor-condos",
    name: "The Stables Motor Condos",
    location: "4375 South Lee Street, Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "under-development",
    acreage: 4.145,
    description:
      "Luxury motor condominiums with office space for exotic-car collectors, on 4.145 acres.",
    images: ["/images/projects/the-stables-motor-condos.jpg"],
    featured: true,
    coordinates: [-83.9932, 34.1198],
  },
  {
    slug: "dogwood-farm-road",
    name: "Dogwood Farm Road",
    location: "Decatur",
    city: "Decatur",
    county: "DeKalb",
    type: "single-family",
    status: "completed",
    acreage: 51,
    description:
      "Sold to DeKalb County, Ga. for a Park and Trail Connection of Greenspace for the future South River Greenway to protect critical habitat along the South River and Snapfinger Creek.",
    images: ["/images/projects/dogwood-farm-road.jpg"],
    coordinates: [-84.2146, 33.6745],
  },
  {
    slug: "pugh-street",
    name: "Peachtree Mill Logistics Center",
    location: "Peachtree Industrial Blvd., Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "industrial",
    status: "under-development",
    acreage: 23.742,
    partner: "Brookfield Properties",
    description:
      "23.742 acres sold to the City of Buford for an industrial assemblage on Peachtree Industrial Blvd., now being developed by Brookfield Properties.",
    images: [],
    coordinates: [-84.003, 34.118],
  },
  {
    slug: "union-grove-subdivision",
    name: "Union Grove Subdivision",
    location: "Union Church Road, Chateau Elan area",
    county: "Hall",
    type: "single-family",
    status: "developed",
    lots: 149,
    acreage: 57.36,
    partner: "Meritage Homes",
    description:
      "57.36-acre single-family detached subdivision with 149 lots near Chateau Elan, developed with Meritage Homes.",
    images: ["/images/projects/union-grove-subdivision.jpg"],
    coordinates: [-83.8415, 34.1301],
  },
  {
    slug: "gardendale",
    name: "Gardendale",
    location: "Hwy. 120 / Howell St., Duluth",
    city: "Duluth",
    county: "Gwinnett",
    type: "townhomes",
    status: "developed",
    lots: 55,
    acreage: 6.0,
    partner: "D.R. Horton",
    description:
      "6.0-acre townhome subdivision with 55 lots developed with D.R. Horton.",
    images: [
      "https://www.atlantatownhomes.com/wp-content/uploads/2022/01/gardendale-11a.jpg",
      "https://www.atlantatownhomes.com/wp-content/uploads/2022/01/gardendale-5a-400x284.jpg",
    ],
    coordinates: [-84.1446, 34.0018],
  },
  {
    slug: "governors-quarters",
    name: "Governors Quarters",
    location: "West 15th St., Hinesville",
    city: "Hinesville",
    county: "Liberty",
    type: "single-family",
    status: "completed",
    lots: 32,
    partner: "Wade Jurney Homes / Century Communities",
    description:
      "32 single-family detached lots near Fort Stewart Army Base. 24 lots sold to Wade Jurney Homes, 8 lots to Century Communities.",
    images: ["/images/projects/governors-quarters.jpg"],
    coordinates: [-81.6533, 31.8257],
  },
  {
    slug: "highland-overlook",
    name: "Highland Overlook",
    location: "Camp Highland Rd., Smyrna",
    city: "Smyrna",
    county: "Cobb",
    type: "townhomes",
    status: "developed",
    lots: 68,
    acreage: 7.75,
    partner: "Meritage Homes",
    description:
      "7.75-acre townhome subdivision with 68 lots developed with Meritage Homes in Smyrna.",
    images: [
      "https://www.atlantatownhomes.com/wp-content/uploads/2020/01/highland-overlook-in-smyrna-9a.jpg",
      "https://www.atlantatownhomes.com/wp-content/uploads/2020/01/highland-overlook-in-smyrna-1a-400x284.jpg",
    ],
    coordinates: [-84.5144, 33.884],
  },
  {
    slug: "stonecreek",
    name: "Stonecreek",
    location: "Highway 81, Loganville",
    city: "Loganville",
    county: "Barrow",
    type: "single-family",
    status: "developed",
    lots: 128,
    acreage: 48,
    partner: "AMH Homes",
    description:
      "48-acre single-family detached subdivision with 128 lots developed with AMH Homes.",
    images: [
      "https://cdn.prod.website-files.com/5cc292e60a7b492ba401361e/63e053644cfa8b5aef1df056_Stone-Creek-Community-Loganville-GA---Print-Quality---089---01-Exterior-Front-1.jpg",
      "https://cdn.prod.website-files.com/5cc292e60a7b492ba401361e/63e053c2a0956fbd92901695_Stone-Creek-Community-Loganville-GA---Print-Quality---065---71-Exterior-Pool.jpg",
      "https://cdn.prod.website-files.com/5cc292e60a7b492ba401361e/63e05399678a170e292f1a21_Stone-Creek-Community-Loganville-GA---Print-Quality---098---19-Exterior-Rear.jpg",
    ],
    coordinates: [-83.9004, 33.837],
  },
  {
    slug: "ashley-falls",
    name: "Ashley Falls",
    location: "Wade Orr Rd., Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "single-family",
    status: "developed",
    lots: 32,
    acreage: 18.12,
    partner: "Century Communities",
    description:
      "18.12-acre single-family detached subdivision with 32 lots developed with Century Communities.",
    images: ["/images/projects/ashley-falls.jpg"],
    coordinates: [-83.9411, 34.1664],
  },
  {
    slug: "the-holbrook",
    name: "The Holbrook",
    location: "Highway 20, Sugar Hill",
    city: "Sugar Hill",
    county: "Gwinnett",
    type: "mixed-use",
    status: "under-development",
    price: "$65,000,000",
    partner: "Solomon Development Group / Trinity Senior Living",
    description:
      "A four-story retail and assisted-living development on the site of a former mobile home park — a $65 million mixed-use project with Solomon Development Group and Trinity Senior Living.",
    images: [
      "https://holbrooklife.com/wp-content/uploads/2023/01/sugar-hill-1.jpg",
      "https://holbrooklife.com/wp-content/uploads/2023/01/sugar-hill-2.jpg",
      "https://holbrooklife.com/wp-content/uploads/2023/03/Luxury-residences-sh-1.jpg",
      "https://holbrooklife.com/wp-content/uploads/2023/02/sugar-hill-image-1.jpg",
    ],
    featured: true,
    coordinates: [-84.0413, 34.1112],
  },
  {
    slug: "towns-at-north-peachtree",
    name: "Towns at North Peachtree",
    location: "North Peachtree Rd., Chamblee",
    city: "Chamblee",
    county: "DeKalb",
    type: "townhomes",
    status: "developed",
    lots: 30,
    acreage: 2.6,
    partner: "Beazer Homes",
    description:
      "2.6-acre, 30 lot townhome subdivision in Chamblee with Beazer Homes.",
    images: [
      "https://www.atlantatownhomes.com/wp-content/uploads/2020/01/towns-at-north-peachtree-townhomes-3a.jpg",
      "https://www.atlantatownhomes.com/wp-content/uploads/2020/01/towns-at-north-peachtree-townhomes-4a.jpg",
      "https://i0.wp.com/homesofchamblee.com/wp-content/uploads/2017/02/Chamblee-GA-Townhome-In-Towns-At-North-Peachtree.jpg",
    ],
    coordinates: [-84.298, 33.887],
  },
  {
    slug: "hadley-township",
    name: "Hadley Township Subdivision",
    location: "Peachtree Industrial Blvd., Sugar Hill",
    city: "Sugar Hill",
    county: "Gwinnett",
    type: "subdivision",
    status: "developed",
    lots: 172,
    acreage: 25.05,
    partner: "Beazer Homes",
    description:
      "25.05-acre mixed subdivision with 55 single-family detached lots and 117 attached townhome lots, developed with Beazer Homes.",
    images: ["/images/projects/hadley-township.jpg"],
    coordinates: [-84.04, 34.1],
  },
  {
    slug: "carramore-subdivision",
    name: "Carramore Subdivision",
    location: "Drew Road, Forsyth County",
    county: "Forsyth",
    type: "single-family",
    status: "developed",
    lots: 19,
    partner: "KM Homes",
    description: "19 single-family detached lots developed with KM Homes.",
    images: ["/images/projects/carramore-subdivision.jpg"],
    coordinates: [-84.2112, 34.2125],
  },
  {
    slug: "roswell-village",
    name: "The Village on Pine",
    location: "Chattahoochee Street, Roswell",
    city: "Roswell",
    county: "Fulton",
    type: "townhomes",
    status: "developed",
    lots: 16,
    partner: "Acadia Homes",
    description:
      "16 townhome lots in historic Roswell developed with Acadia Homes.",
    images: [],
    coordinates: [-84.3616, 34.0232],
  },
  {
    slug: "peachtree-preserve",
    name: "Peachtree Preserve",
    location: "Bush Road, Peachtree Corners",
    city: "Peachtree Corners",
    county: "Gwinnett",
    type: "subdivision",
    status: "developed",
    lots: 16,
    partner: "Reliance Development Company",
    description:
      "16-lot residential subdivision developed with Reliance Development Company.",
    images: ["/images/projects/peachtree-preserve.jpg"],
    coordinates: [-84.2058, 33.9842],
  },
  {
    slug: "u-club-on-frey-phase-2",
    name: "U Club on Frey — Phase II",
    location: "Frey Road at Shiloh Road, Kennesaw",
    city: "Kennesaw",
    county: "Cobb",
    type: "student-housing",
    status: "developed",
    beds: 432,
    units: 140,
    acreage: 6.317,
    partner: "American Campus Communities",
    description:
      "Phase II expansion of the U Club on Frey student housing community near Kennesaw State University. 432 beds across 140 units.",
    images: [
      "https://www.americancampus.com/getmedia/db8f9c83-31ae-457a-a0f7-cab6d12ed80f/496_12_Gallery_730x547.jpg",
      "https://www.americancampus.com/getmedia/1fdbfe96-4c33-4fe9-b4aa-653d777f3e41/496_13_Gallery_730x547.jpg",
    ],
    coordinates: [-84.612, 34.028],
  },
  {
    slug: "u-club-on-frey",
    name: "U Club on Frey",
    location: "Frey Road at Shiloh Road, Kennesaw",
    city: "Kennesaw",
    county: "Cobb",
    type: "student-housing",
    status: "fully-leased",
    beds: 500,
    units: 170,
    acreage: 6.517,
    partner: "American Campus Communities",
    description:
      "500-bed, 170-unit student housing community developed with American Campus Communities, a third of a mile from Kennesaw State University.",
    images: [
      "/images/projects/u-club-on-frey-1.jpg",
      "https://www.americancampus.com/getmedia/16b8f1d8-2f7d-450c-8e79-bc879949a685/496_03_Gallery_730x547.jpg",
      "https://www.americancampus.com/getmedia/adcf76b4-8a04-4833-845d-5bd2ab2717a4/496_05_Gallery_730x547.jpg",
      "https://www.americancampus.com/getmedia/dc646063-ba23-4141-939b-106dcdcff29a/496_06_Gallery_730x547.jpg",
    ],
    featured: true,
    coordinates: [-84.6155, 34.0234],
  },
  {
    slug: "campbellton-road",
    name: "Campbellton Road",
    location: "Atlanta",
    city: "Atlanta",
    county: "Fulton",
    type: "commercial",
    status: "completed",
    acreage: 4.199,
    description:
      "4.199-acre commercial site acquired from the Atlanta YWCA, developed for a daycare and a convenience store.",
    images: [],
    coordinates: [-84.4785, 33.7043],
  },
  {
    slug: "walden-at-oakwood",
    name: "Walden at Oakwood",
    location: "Oakwood",
    city: "Oakwood",
    county: "Hall",
    type: "luxury-apartments",
    status: "developed",
    units: 300,
    acreage: 35,
    partner: "Walden Communities",
    description:
      "35-acre tract rezoned for 300 apartment units and six commercial lots, developed with Walden Communities.",
    images: [
      "https://www.waldenatoakwood.com/images/home-box-image-1.jpg",
      "https://www.waldenatoakwood.com/images/home-box-image-3.jpg",
    ],
    coordinates: [-83.884, 34.229],
  },
  {
    slug: "dalys-truck-driving-school",
    name: "Daly's Truck Driving School",
    location: "Peachtree Industrial Blvd., Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "developed",
    acreage: 5.9823,
    partner: "Metal Building Associates",
    description:
      "5.9823-acre commercial development for truck driving school with Metal Building Associates.",
    images: ["/images/projects/dalys-truck-driving-school.jpg"],
    coordinates: [-84.0081, 34.1316],
  },
  {
    slug: "madison-subdivision",
    name: "Madison Subdivision",
    location: "Post Road, Forsyth County",
    county: "Forsyth",
    type: "subdivision",
    status: "developed",
    lots: 90,
    partner: "Landstar Corporation",
    description: "90-lot residential subdivision with Landstar Corporation.",
    images: ["/images/projects/madison-subdivision.jpg"],
    coordinates: [-84.2273, 34.2255],
  },
  {
    slug: "kelly-crossing",
    name: "The Park at Kelly Mill",
    location: "Bantry Way & Kelly Mill Road, Cumming",
    county: "Forsyth",
    type: "subdivision",
    status: "completed",
    lots: 30,
    description: "30 residential lots, sold after development.",
    images: ["/images/projects/kelly-crossing.jpg"],
    coordinates: [-84.2094048, 34.204634],
  },
  {
    slug: "brookside-subdivision",
    name: "Brookside Subdivision",
    location: "Hyde Road, Forsyth County",
    county: "Forsyth",
    type: "subdivision",
    status: "developed",
    lots: 77,
    partner: "Landstar Corporation",
    description: "77-lot residential subdivision with Landstar Corporation.",
    images: ["/images/projects/brookside-subdivision.jpg"],
    coordinates: [-84.2418, 34.2328],
  },
  {
    slug: "la-petite-daycare",
    name: "Bright Star Kids Academy",
    location: "1980 Buford Highway, Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "completed",
    description:
      "Mixed commercial development; the daycare was later resold to a flooring company.",
    images: ["/images/projects/bright-star-daycare.jpg"],
    coordinates: [-84.002417, 34.108062],
  },
  {
    slug: "morningside-dental-office",
    name: "Morningside Dental Office",
    location: "1900 Morningside Drive, Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "completed",
    acreage: 1.13,
    description:
      "1.13-acre commercial site at 1900 Morningside Drive in Buford, sold and developed as a professional dental office.",
    images: ["/images/projects/dental-office-morningside.jpg"],
    coordinates: [-84.003032, 34.108072],
  },
  {
    slug: "gravel-springs-garage-lofts",
    name: "Gravel Springs Garage Lofts",
    location: "3270 Gravel Springs Road, Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "completed",
    description:
      "Provided the land for a garage-loft and office / warehouse-condominium development at 3270 Gravel Springs Road in Buford.",
    images: ["/images/projects/gravel-springs-garage-lofts.jpg"],
    coordinates: [-83.97776, 34.07286],
  },
  {
    slug: "puckett-creek",
    name: "Puckett Creek Subdivision",
    location: "City of Canton",
    city: "Canton",
    county: "Cherokee",
    type: "subdivision",
    status: "developed",
    lots: 199,
    partner: "Capital Communities",
    description:
      "Rezoned from Agricultural to R2, 199 lots adjacent to the Laurel Canyon project, developed with Capital Communities.",
    images: ["/images/projects/puckett-creek.jpg"],
    coordinates: [-84.5038, 34.2584],
  },
  {
    slug: "rose-creek-phase-3",
    name: "Rose Creek Phase III",
    location: "Rose Creek Drive & Matt Highway, Cumming",
    county: "Forsyth",
    type: "subdivision",
    status: "completed",
    lots: 71,
    partner: "Breedlove Industries",
    description:
      "71 lots rezoned from Agricultural to RES-3, sold to Breedlove Industries.",
    images: ["/images/projects/rose-creek-phase-3.jpg"],
    coordinates: [-84.1321555, 34.2896189],
  },
  {
    slug: "carriage-park",
    name: "Carriage Park Subdivision",
    location: "Forsyth County",
    county: "Forsyth",
    type: "subdivision",
    status: "developed",
    lots: 40,
    partner: "Cauley-Stevens",
    description:
      "40 lots rezoned from Agricultural to RES-3, developed with Cauley-Stevens.",
    images: ["/images/projects/carriage-park.jpg"],
    coordinates: [-84.22, 34.211],
  },
  {
    slug: "carriage-post",
    name: "Carriage Post Subdivision",
    location: "Forsyth County",
    county: "Forsyth",
    type: "subdivision",
    status: "developed",
    lots: 21,
    partner: "Cauley-Stevens",
    description:
      "21 lots rezoned from Agricultural to RES-3, developed with Cauley-Stevens.",
    images: ["/images/projects/carriage-post.jpg"],
    coordinates: [-84.222, 34.2161],
  },
  {
    slug: "regency-park",
    name: "Regency Park Subdivision",
    location: "Emperor Lane & Dee Kennedy Road, Hoschton",
    county: "Barrow",
    type: "single-family",
    status: "completed",
    lots: 48,
    partner: "Homeland Communities",
    description:
      "48 one-acre lots rezoned from Agricultural to R-100. Sold all 48 lots in one closing to Homeland Communities.",
    images: ["/images/projects/regency-park.jpg"],
    coordinates: [-83.8362994, 34.0647109],
  },
  {
    slug: "south-lee-street",
    name: "South Lee Street",
    location: "City of Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "developed",
    acreage: 5.88,
    description:
      "5.88 acres rezoned from Agricultural to C-2 for office, retail, and warehousing.",
    images: ["/images/projects/south-lee-street.jpg"],
    coordinates: [-83.994, 34.122],
  },
  {
    slug: "lincoln-park",
    name: "Lincoln Park Subdivision",
    location: "Chicken Lyle Road, Barrow County",
    county: "Barrow",
    type: "subdivision",
    status: "developed",
    lots: 63,
    partner: "Rip Star Development",
    description:
      "63-lot subdivision developed with Rip Star Development in Barrow County.",
    images: ["/images/projects/lincoln-park.jpg"],
    coordinates: [-83.7408, 34.037],
  },
  {
    slug: "morgans-crossing",
    name: "Morgan's Crossing Subdivision",
    location: "Ridge Road & Morgans Ridge Drive, Buford",
    county: "Gwinnett",
    type: "single-family",
    status: "completed",
    lots: 31,
    description:
      "31 lots rezoned from Agricultural to R-100. Sold all 31 lots in one closing.",
    images: ["/images/projects/morgans-crossing.jpg"],
    coordinates: [-83.9358775, 34.1203786],
  },
  {
    slug: "highway-124-hamilton-mill",
    name: "Highway 124 @ Hamilton Mill",
    location: "Gwinnett County",
    county: "Gwinnett",
    type: "commercial",
    status: "completed",
    acreage: 8.14,
    description:
      "8.14 acres of professional offices, rezoned from Agricultural to C-1.",
    images: [],
    coordinates: [-83.918, 34.015],
  },
  {
    slug: "wheeler-road",
    name: "Wheeler Road",
    location: "Gwinnett County",
    county: "Gwinnett",
    type: "single-family",
    status: "completed",
    acreage: 7.5,
    description: "7.5 acres separated into estate lots by exemption plat.",
    images: [],
    coordinates: [-83.945, 33.975],
  },
  {
    slug: "thunder-road",
    name: "Thunder Road",
    location: "City of Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "industrial",
    status: "completed",
    acreage: 1.25,
    description:
      "1.25-acre industrial lot rezoned C-2 for a sod and landscaping company.",
    images: [],
    coordinates: [-83.9766, 34.1431],
  },
  {
    slug: "old-hog-mountain-road",
    name: "Old Hog Mountain Road",
    location: "Gwinnett County",
    county: "Gwinnett",
    type: "single-family",
    status: "completed",
    description:
      "4 lots at 0.75 acres each and 2 lots at 1.5 acres each, separated into estate lots by exemption plat.",
    images: [],
    coordinates: [-83.933, 33.995],
  },
  {
    slug: "hamilton-springs",
    name: "Hamilton Springs Subdivision",
    location: "Gold Springs Lane & Mineral Springs Road, Hoschton",
    county: "Gwinnett",
    type: "subdivision",
    status: "developed",
    lots: 50,
    partner: "Subdivision Developer's, Inc.",
    description:
      "50 lots rezoned from Agricultural to R-100, developed with Subdivision Developer's, Inc.",
    images: ["/images/projects/hamilton-springs.jpg"],
    coordinates: [-83.8779384, 34.057908],
  },
  {
    slug: "highway-324",
    name: "Highway 324",
    location: "Highway 324 / Gravel Springs Rd. at Cross Rd., Buford",
    city: "Buford",
    county: "Gwinnett",
    type: "commercial",
    status: "completed",
    acreage: 7.5,
    description:
      "7.5-acre site next to Mall of Georgia; estate lots separated by exemption plat and sold as commercial after Mall of Georgia construction began.",
    images: ["/images/projects/highway-324.jpg"],
    coordinates: [-83.9782335, 34.0736369],
  },
  {
    slug: "indian-hills",
    name: "Indian Hills Subdivision",
    location: "Wapakonata Trail & Indian Shoals Road SE, Bethlehem",
    county: "Gwinnett",
    type: "subdivision",
    status: "developed",
    lots: 45,
    partner: "Subdivision Developer's, Inc.",
    description:
      "45 lots rezoned from Agricultural to R-100, developed with Subdivision Developer's, Inc.",
    images: ["/images/projects/indian-hills.jpg"],
    coordinates: [-83.8189683, 33.9483075],
  },
  {
    slug: "harbins-station",
    name: "Harbin's Station Subdivision",
    location: "Barrow County",
    county: "Barrow",
    type: "subdivision",
    status: "completed",
    lots: 42,
    description:
      "42 lots rezoned from Agricultural to R-100. Sold all 42 lots in one closing.",
    images: ["/images/projects/harbins-station.jpg"],
    coordinates: [-83.728, 33.985],
  },
  {
    slug: "muirfield",
    name: "Muirfield Subdivision",
    location: "Barrow County",
    county: "Barrow",
    type: "subdivision",
    status: "completed",
    lots: 25,
    description:
      "25 lots rezoned from Agricultural to R-100. Sold all 25 lots in one closing.",
    images: ["/images/projects/muirfield.jpg"],
    coordinates: [-83.7891, 34.0229],
  },
  {
    slug: "stonebrooke",
    name: "Stonebrooke Subdivision",
    location: "Stonebrooke Drive & Kilcrease Drive, Auburn",
    county: "Gwinnett",
    type: "subdivision",
    status: "developed",
    lots: 20,
    description:
      "20 lots rezoned from Agricultural to R-100.",
    images: ["/images/projects/stonebrooke.jpg"],
    coordinates: [-83.822755, 33.9890811],
  },
  {
    slug: "stonemont",
    name: "Stonemont Subdivision",
    location: "Barrow County",
    county: "Barrow",
    type: "subdivision",
    status: "developed",
    lots: 13,
    description: "13 lots rezoned from Agricultural to R-100.",
    images: ["/images/projects/stonemont.jpg"],
    coordinates: [-83.8249, 33.9787],
  },
];
